import React from 'react'
import PropTypes from 'prop-types'
import { Card } from './'
import { SecondaryHeading } from 'ui/headings'
import CardHeader from 'ui/cards/CardHeader'

function CardWithHeader ({ children, header, className, withMargin = true }) {
  return (
    <Card className={className}>
      <CardHeader withMargin={withMargin}>
        <SecondaryHeading>
          {header}
        </SecondaryHeading>
      </CardHeader>
      {children}
    </Card>
  )
}

CardWithHeader.defaultProps = {
  header: null
}

CardWithHeader.propTypes = {
  header: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]).isRequired
}

export default CardWithHeader
